/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formvalidation_Invalidurl2Inputs */

const en_formvalidation_invalidurl2 = /** @type {(inputs: Formvalidation_Invalidurl2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid URL starting with https:// (e.g., https://example.com)`)
};

/**
* | output |
* | --- |
* | "Please enter a valid URL starting with https:// (e.g., https://example.com)" |
*
* @param {Formvalidation_Invalidurl2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formvalidation_invalidurl2 = /** @type {((inputs?: Formvalidation_Invalidurl2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formvalidation_Invalidurl2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formvalidation_invalidurl2(inputs)
});
export { formvalidation_invalidurl2 as "formValidation_invalidUrl" }